import { InputBlock } from '@coast/schemas/index';
import { useCallback, useContext, useMemo } from 'react';
import { useCardFormContext } from '@shared/components/blocks/contexts/form';
import { getTypoComponent } from '@shared/components/blocks/utils';
import { ColorThemeContext } from '@shared/styles';
import { renderToggle } from './input';
import { MBCardInputBlockBase } from './input/base';

interface Props {
  block: InputBlock;
}

export function MBCardInputBlockToggle({ block }: Props) {
  const colors = useContext(ColorThemeContext);
  const { setFieldValue, values } = useCardFormContext();
  const TypoComponent = getTypoComponent(block.textStyle);

  const value = values[block.name];
  const onChange = useCallback(
    (updatedValue: boolean) => setFieldValue(block.name, updatedValue),
    [setFieldValue, block.name],
  );

  const renderRight = useMemo(() => () => renderToggle(value, onChange), [value, onChange]);

  return (
    // @ts-expect-error -- strict migration
    <MBCardInputBlockBase block={block} renderLabel={null} renderRight={renderRight}>
      <TypoComponent color={colors.foregroundActive}>{block.label}</TypoComponent>
    </MBCardInputBlockBase>
  );
}
